<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('autoHistory.title') }} - {{ autoTitle }}
          </h1>
          <div
            v-if="dataIsLoading"
            class="progress d-flex justify-center align-center mt-4"
          >
            <v-progress-circular :size="70" color="warning" indeterminate />
          </div>
          <!-- Auto history table -->
          <v-layout wrap align-center v-if="!dataIsLoading">
            <v-flex xs12>
              <v-data-table
                id="autoHistory"
                :items="autoHistory.items"
                :headers="headers"
                :loading="isLoading"
                :loading-text="$t('common.table.dataIsLoading')"
                :server-items-length="2"
                :mobile-breakpoint="100"
                class="table-custom autoHistory small mb-4"
                hide-default-footer
              >
                <template slot="item" slot-scope="{ item }">
                  <tr>
                    <td class="text-xs-left">{{ item.num }}</td>
                    <td class="text-xs-left">{{ item.email }}</td>
                    <td class="text-xs-left">{{ item.key }}</td>
                    <td class="text-xs-left details">{{ item.result }}</td>
                    <td class="text-xs-left">{{ item.createdAt }}</td>
                  </tr>
                </template>
                <template slot="no-data">{{
                  $t('common.table.noData')
                }}</template>
              </v-data-table>
              <div v-if="paginationPage" class="text-xs-center">
                <v-pagination
                  :value="paginationPage"
                  :length="paginationLength"
                  @input="choosePaginatorPage($event)"
                ></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import store from '@/store';
import hasPermission from '@/helpers/hasPermission';

export default {
  name: 'AutoHistoryPage',
  beforeRouteEnter(to, from, next) {
    const isInvestor = store.getters['global/getRole'] === 'investor';
    if (!isInvestor || hasPermission('investor_car_change_history')) next();
  },
  data() {
    return {
      dataIsLoading: false,
      headers: [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('autoHistory.tableHeaders.user'), sortable: false },
        { text: this.$t('autoHistory.tableHeaders.action'), sortable: false },
        { text: this.$t('autoHistory.tableHeaders.details'), sortable: false },
        { text: this.$t('autoHistory.tableHeaders.date'), sortable: false },
      ],
    };
  },
  watch: {
    /* eslint-disable */
    '$i18n.locale': async function() {
      await this.fetchAutoHistory({
        page: this.paginationPage,
        autoId: this.$route.params.autoId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
  computed: {
    ...mapGetters({
      autoTitle: 'auto/getAutoTitle',
      isLoading: 'global/getLoader',
      autoHistory: 'auto/getAutoHistoryData',
    }),
    paginationLength() {
      return this.autoHistory.lastPage;
    },
    paginationPage() {
      if (
        this.autoHistory.currentPage === 1 &&
        this.autoHistory.lastPage === 1
      ) {
        return 0;
      }
      return this.autoHistory.currentPage;
    },
  },
  async created() {
    this.dataIsLoading = true;
    try {
      await this.fetchAutoHistory({
        page: 1,
        autoId: this.$route.params.autoId,
      });
      this.dataIsLoading = false;
    } catch (error) {
      if (error.status === 404) {
        this.$router.push({ name: 'not-found' });
        return;
      }
      this.dataIsLoading = false;
    }
  },
  destroyed() {
    this.clearAlertError();
    this.setAutoHistoryData({});
  },
  methods: {
    ...mapActions({
      fetchAutoHistory: 'auto/fetchAutoHistoryData',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      setAutoHistoryData: 'auto/setAutoHistoryData',
    }),
    async choosePaginatorPage(page) {
      await this.fetchAutoHistory({
        page,
        autoId: this.$route.params.autoId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
};
</script>

<style lang="scss" scoped></style>
